var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',_vm._g(_vm._b({attrs:{"value":_vm.value},on:{"input":_vm.onInput,"change":_vm.onChange}},'b-form-input',_vm.$attrs,false),_vm.forwardedListeners))}
var staticRenderFns = []

export { render, staticRenderFns }